import { render } from "./RiUser.vue?vue&type=template&id=2a901998"
import script from "./RiUser.vue?vue&type=script&lang=js"
export * from "./RiUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a901998"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a901998', __exports__)) {
    api.reload('2a901998', __exports__)
  }
  
  module.hot.accept("./RiUser.vue?vue&type=template&id=2a901998", () => {
    api.rerender('2a901998', render)
  })

}


export default __exports__